(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitchkits-league-club-browser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pitchkits-league-browser')) {
    customElements.define(
      'pitchkits-league-browser',
      class PitchKitsLeagueBrowser extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(tab));
            tab.addEventListener('keydown', (event) => {
              if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
              event.preventDefault();
              const direction = event.key === 'ArrowRight' ? 1 : -1;
              const next = this.tabs[(index + direction + this.tabs.length) % this.tabs.length];
              this.select(next);
              next.focus();
            });
          });
        }

        select(activeTab) {
          this.tabs.forEach((tab) => {
            const selected = tab === activeTab;
            tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            tab.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector(`#${tab.dataset.panel}`);
            if (panel) panel.hidden = !selected;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
